import React from 'react';
import HelpApiLayout from '../../../../components/layout/HelpApiLayout';
import HelpSidebar from '../../../../components/layout/HelpSidebar';
import ArticleNavigation from '../../../../components/layout/docs/ArticleNavigation';
import LastUpdated from '../../../../components/layout/docs/LastUpdated';
import { getHelpArticleRoute } from '../../../../constants/routes';
import { getHelpRoute } from '../../../../utils/navigation';
import '../getting-started/HelpCategoryPage.css';

/**
 * Gas Fees Article Page
 */
const GasFees = () => {
  return (
    <HelpApiLayout type="help" sidebar={<HelpSidebar />}>
      <div className="help-category-page">
        <div className="help-category-container">
          <main className="help-category-main">
            <div className="article-content">
              <header className="article-header">
                <h1 className="article-title">Gas Fees</h1>
                <p className="article-subtitle">
                  Discover how WeSplit handles blockchain network fees, allowing you to use the app without ever needing to buy or hold SOL.
                </p>
              </header>

              <div className="article-separator"></div>

              <section className="article-section">
                <div className="article-subsection">
                  <h2 className="article-section-title">Overview</h2>
                  <p className="article-section-intro">
                    Typically, using a crypto wallet on the Solana network requires you to hold a small amount of the native token (SOL) to pay for 'gas,' or network transaction fees. WeSplit removes this complexity entirely.
                  </p>
                </div>
              </section>

              <section className="article-section">
                <div className="article-subsection">
                  <h2 className="article-section-title">Zero Gas for Users</h2>
                  <p className="article-section-intro">
                    WeSplit utilizes a Sponsored Transaction model (often called 'Gasless').
                  </p>
                </div>

                <div className="article-subsection">
                  <ul className="article-list-dots">
                    <li>
                      <strong>We Pay the Bill:</strong> For every action you take in the app—whether it's sending money, splitting a bill, or creating a group—WeSplit covers the network cost for you.
                    </li>
                    <li>
                      <strong>No SOL Needed:</strong> You do not need to buy, hold, or manage SOL tokens in your wallet. You can operate entirely using just USDC.
                    </li>
                  </ul>
                </div>
              </section>

              <section className="article-section">
                <div className="article-subsection">
                  <h2 className="article-section-title">Why This Matters</h2>
                </div>

                <div className="article-subsection">
                  <ul className="article-list-dots">
                    <li>
                      <strong>Frictionless Experience:</strong> You will never encounter an 'Insufficient funds for gas' error.
                    </li>
                    <li>
                      <strong>Simpler Management:</strong> You don't need to juggle two different currencies (SOL for fees + USDC for payments). Just top up your account with USDC, and you are ready to go.
                    </li>
                  </ul>
                </div>
              </section>

              <div className="article-separator"></div>

              <LastUpdated />

              <ArticleNavigation
                previous={{
                  title: 'Request (P2P)',
                  route: getHelpRoute(getHelpArticleRoute('features', 'request-p2p'))
                }}
                next={{
                  title: 'Rewards',
                  route: getHelpRoute(getHelpArticleRoute('features', 'rewards'))
                }}
              />
            </div>
          </main>
        </div>
      </div>
    </HelpApiLayout>
  );
};

export default GasFees;
